import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const LIST_BANK_SHARED_MEDIAS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'listBankSharedMedias',
    operationName: 'listBankSharedMedias',
    args: [
      { name: 'parent_type', type: 'String', required: true },
      { name: 'parent_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'parent_type', value: 'parent_type' },
      { name: 'parent_id', value: 'parent_id' },
    ],
    fields: '{...BankSharedMediaListResponseFields}',
    fragments: [Fragments.bankSharedMediaListResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const GET_BANK_SHARED_MEDIA = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getBankSharedMedia',
    operationName: 'getBankSharedMedia',
    args: [
      { name: 'shared_media_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'shared_media_id', value: 'shared_media_id' },
    ],
    fields: '{...BankSharedMediaResponseFields}',
    fragments: [Fragments.bankSharedMediaResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const GET_BANK_SHARED_MEDIA_FILE = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getBankSharedMediaFile',
    args: [
      { name: 'shared_media_id', type: 'String', required: true },
      { name: 'file_name', type: 'String', required: true },
      { name: 'dl', type: 'String' },
    ],
    argsMap: [
      { name: 'shared_media_id', value: 'shared_media_id' },
      { name: 'file_name', value: 'file_name' },
      { name: 'dl', value: 'dl' },
    ],
    fields: `{
      file_content
      content_type
      content_disposition
      cache_control
      file_name
      url
    }`,
    fragments: [],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const STREAM_BANK_SHARED_MEDIA_FILE = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'streamBankSharedMediaFile',
    operationName: 'streamBankSharedMediaFile',
    args: [
      { name: 'shared_media_id', type: 'String', required: true },
      { name: 'file_name', type: 'String', required: true },
      { name: 'dl', type: 'String' },
    ],
    argsMap: [
      { name: 'shared_media_id', value: 'shared_media_id' },
      { name: 'file_name', value: 'file_name' },
      { name: 'dl', value: 'dl' },
    ],
    fields: '{...StreamBankSharedMediaFileResponseFields}',
    fragments: [Fragments.streamBankSharedMediaFileResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
